import { TuiPaginationModule } from '@taiga-ui/kit';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { NgClass, NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'iss-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: [ './paginator.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    NgFor,
    TuiPaginationModule,
  ],
})
export class PaginatorComponent {
  @Input() public currentPage = 1;
  @Input() public numberOfPages = 1;
  @Output() public readonly currentPageChange = new EventEmitter<number>();
}
